/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkConfirmScreendeviceResponseDto } from '../models/work-confirm-screendevice-response-dto';
import { WorkConnectResponseDto } from '../models/work-connect-response-dto';
import { WorkConnectScreendeviceDto } from '../models/work-connect-screendevice-dto';
import { WorkCreateScreendeviceDto } from '../models/work-create-screendevice-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkRegisterScreendeviceDto } from '../models/work-register-screendevice-dto';
import { WorkScreendevice } from '../models/work-screendevice';
import { WorkSetAlwaysOnDto } from '../models/work-set-always-on-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateScreendeviceDto } from '../models/work-update-screendevice-dto';

@Injectable({ providedIn: 'root' })
export class WorkScreendevicesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `screendevicesV2ControllerFindAllPaginated()` */
  static readonly ScreendevicesV2ControllerFindAllPaginatedPath = '/v2/screendevices';

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by confirmed query param.
     *           <p>
     *              <b>Format: </b> filter.confirmed={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.confirmed=$not:$like:John Doe&filter.confirmed=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.confirmed'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>uniqueIdentifier</li>
     * <li>ipAddress</li>
     * <li>created</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'uniqueIdentifier:ASC' | 'uniqueIdentifier:DESC' | 'ipAddress:ASC' | 'ipAddress:DESC' | 'created:ASC' | 'created:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,uniqueIdentifier
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>uniqueIdentifier</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkScreendevice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'confirmed'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.confirmed', params['filter.confirmed'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkScreendevice>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'confirmed'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by confirmed query param.
     *           <p>
     *              <b>Format: </b> filter.confirmed={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.confirmed=$not:$like:John Doe&filter.confirmed=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.confirmed'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>uniqueIdentifier</li>
     * <li>ipAddress</li>
     * <li>created</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'uniqueIdentifier:ASC' | 'uniqueIdentifier:DESC' | 'ipAddress:ASC' | 'ipAddress:DESC' | 'created:ASC' | 'created:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,uniqueIdentifier
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>uniqueIdentifier</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkScreendevice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'confirmed'?: (string | Array<string>);
};
};
}> {
    return this.screendevicesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkScreendevice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'confirmed'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkScreendevice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'confirmed'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerCreate()` */
  static readonly ScreendevicesV2ControllerCreatePath = '/v2/screendevices';

  /**
   * Required permissions: screen:create, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screendevicesV2ControllerCreate$Response(
    params: {
      body: WorkCreateScreendeviceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreendevice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreendevice>;
      })
    );
  }

  /**
   * Required permissions: screen:create, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screendevicesV2ControllerCreate(
    params: {
      body: WorkCreateScreendeviceDto
    },
    context?: HttpContext
  ): Observable<WorkScreendevice> {
    return this.screendevicesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreendevice>): WorkScreendevice => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerFindAllActive()` */
  static readonly ScreendevicesV2ControllerFindAllActivePath = '/v2/screendevices/active-list';

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerFindAllActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerFindAllActive$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkScreendevice>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerFindAllActivePath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkScreendevice>>;
      })
    );
  }

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerFindAllActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerFindAllActive(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkScreendevice>> {
    return this.screendevicesV2ControllerFindAllActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkScreendevice>>): Array<WorkScreendevice> => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerSetAlwaysOnForAll()` */
  static readonly ScreendevicesV2ControllerSetAlwaysOnForAllPath = '/v2/screendevices/bulk/always-on';

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerSetAlwaysOnForAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screendevicesV2ControllerSetAlwaysOnForAll$Response(
    params: {
      body: WorkSetAlwaysOnDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkScreendevice>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerSetAlwaysOnForAllPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkScreendevice>>;
      })
    );
  }

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerSetAlwaysOnForAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screendevicesV2ControllerSetAlwaysOnForAll(
    params: {
      body: WorkSetAlwaysOnDto
    },
    context?: HttpContext
  ): Observable<Array<WorkScreendevice>> {
    return this.screendevicesV2ControllerSetAlwaysOnForAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkScreendevice>>): Array<WorkScreendevice> => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerFindById()` */
  static readonly ScreendevicesV2ControllerFindByIdPath = '/v2/screendevices/{id}';

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerFindById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreendevice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreendevice>;
      })
    );
  }

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerFindById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkScreendevice> {
    return this.screendevicesV2ControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreendevice>): WorkScreendevice => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerDelete()` */
  static readonly ScreendevicesV2ControllerDeletePath = '/v2/screendevices/{id}';

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.screendevicesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerUpdate()` */
  static readonly ScreendevicesV2ControllerUpdatePath = '/v2/screendevices/{id}';

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screendevicesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateScreendeviceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreendevice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreendevice>;
      })
    );
  }

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screendevicesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateScreendeviceDto
    },
    context?: HttpContext
  ): Observable<WorkScreendevice> {
    return this.screendevicesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreendevice>): WorkScreendevice => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerFindByUniqueIdentifier()` */
  static readonly ScreendevicesV2ControllerFindByUniqueIdentifierPath = '/v2/screendevices/byUniqueIdentifier/{uniqueIdentifier}';

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerFindByUniqueIdentifier()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerFindByUniqueIdentifier$Response(
    params: {
      uniqueIdentifier: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreendevice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerFindByUniqueIdentifierPath, 'get');
    if (params) {
      rb.path('uniqueIdentifier', params.uniqueIdentifier, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreendevice>;
      })
    );
  }

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerFindByUniqueIdentifier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerFindByUniqueIdentifier(
    params: {
      uniqueIdentifier: string;
    },
    context?: HttpContext
  ): Observable<WorkScreendevice> {
    return this.screendevicesV2ControllerFindByUniqueIdentifier$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreendevice>): WorkScreendevice => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerAddSlideToDevice()` */
  static readonly ScreendevicesV2ControllerAddSlideToDevicePath = '/v2/screendevices/{id}/slides/{slideId}/{position}';

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerAddSlideToDevice()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerAddSlideToDevice$Response(
    params: {
      id: number;
      slideId: number;
      position: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerAddSlideToDevicePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('slideId', params.slideId, {});
      rb.path('position', params.position, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerAddSlideToDevice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerAddSlideToDevice(
    params: {
      id: number;
      slideId: number;
      position: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.screendevicesV2ControllerAddSlideToDevice$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerRemoveSlideFromDevice()` */
  static readonly ScreendevicesV2ControllerRemoveSlideFromDevicePath = '/v2/screendevices/{id}/slides/{slideId}';

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerRemoveSlideFromDevice()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerRemoveSlideFromDevice$Response(
    params: {
      id: number;
      slideId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerRemoveSlideFromDevicePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('slideId', params.slideId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerRemoveSlideFromDevice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerRemoveSlideFromDevice(
    params: {
      id: number;
      slideId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.screendevicesV2ControllerRemoveSlideFromDevice$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerPowerOn()` */
  static readonly ScreendevicesV2ControllerPowerOnPath = '/v2/screendevices/{id}/power/on';

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerPowerOn()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerPowerOn$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreendevice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerPowerOnPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreendevice>;
      })
    );
  }

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerPowerOn$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerPowerOn(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkScreendevice> {
    return this.screendevicesV2ControllerPowerOn$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreendevice>): WorkScreendevice => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerPowerOff()` */
  static readonly ScreendevicesV2ControllerPowerOffPath = '/v2/screendevices/{id}/power/off';

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerPowerOff()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerPowerOff$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreendevice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerPowerOffPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreendevice>;
      })
    );
  }

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerPowerOff$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerPowerOff(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkScreendevice> {
    return this.screendevicesV2ControllerPowerOff$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreendevice>): WorkScreendevice => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerRestart()` */
  static readonly ScreendevicesV2ControllerRestartPath = '/v2/screendevices/{id}/restart';

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerRestart()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerRestart$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreendevice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerRestartPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreendevice>;
      })
    );
  }

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerRestart$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerRestart(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkScreendevice> {
    return this.screendevicesV2ControllerRestart$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreendevice>): WorkScreendevice => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerRegister()` */
  static readonly ScreendevicesV2ControllerRegisterPath = '/v2/screendevices/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerRegister()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screendevicesV2ControllerRegister$Response(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkRegisterScreendeviceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConfirmScreendeviceResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerRegisterPath, 'post');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConfirmScreendeviceResponseDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerRegister$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screendevicesV2ControllerRegister(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkRegisterScreendeviceDto
    },
    context?: HttpContext
  ): Observable<WorkConfirmScreendeviceResponseDto> {
    return this.screendevicesV2ControllerRegister$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConfirmScreendeviceResponseDto>): WorkConfirmScreendeviceResponseDto => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerFindDataByUniqueIdentifier()` */
  static readonly ScreendevicesV2ControllerFindDataByUniqueIdentifierPath = '/v2/screendevices/data/{uniqueIdentifier}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerFindDataByUniqueIdentifier()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerFindDataByUniqueIdentifier$Response(
    params: {
      uniqueIdentifier: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreendevice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerFindDataByUniqueIdentifierPath, 'get');
    if (params) {
      rb.path('uniqueIdentifier', params.uniqueIdentifier, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreendevice>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerFindDataByUniqueIdentifier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screendevicesV2ControllerFindDataByUniqueIdentifier(
    params: {
      uniqueIdentifier: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<WorkScreendevice> {
    return this.screendevicesV2ControllerFindDataByUniqueIdentifier$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreendevice>): WorkScreendevice => r.body)
    );
  }

  /** Path part for operation `screendevicesV2ControllerConnect()` */
  static readonly ScreendevicesV2ControllerConnectPath = '/v2/screendevices/connect';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screendevicesV2ControllerConnect()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screendevicesV2ControllerConnect$Response(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkConnectScreendeviceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkConnectResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreendevicesV2Service.ScreendevicesV2ControllerConnectPath, 'post');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkConnectResponseDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screendevicesV2ControllerConnect$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screendevicesV2ControllerConnect(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkConnectScreendeviceDto
    },
    context?: HttpContext
  ): Observable<WorkConnectResponseDto> {
    return this.screendevicesV2ControllerConnect$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkConnectResponseDto>): WorkConnectResponseDto => r.body)
    );
  }

}
